import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";

import NotFoundPage from "../pages/not-found";

/** guest page */
import LoginPage from "../pages/guest/pages/login";
import ForgotPasswordPage from "../pages/guest/pages/forgot-password";
import ResetPasswordPage from "../pages/guest/pages/forgot-password/reset";
import SetPasswordPage from "../pages/guest/pages/login/pages/set-password";
import SignupPage from "../pages/guest/pages/signup/index";
import SignupSuccess from "../pages/guest/pages/signup/success";
import SignupCancel from "../pages/guest/pages/signup/cancel";
/** leads page */
import LeadsPage from "../pages/leads/app";

import PublicRoute from "./public";
import LeadsRoute from "./leads";
import ReactGA from "react-ga4";
import ApiKeyGenerator from "../pages/guest/pages/apikey-generator";
import { APP_NAME, APP_VERSION } from "../constant";

const AppRoute = () => {
  const TRACKING_ID = "G-PVQ2PM0YCT";
  ReactGA.initialize(TRACKING_ID);

  // HOOKS
  useEffect(() => {
    const lastVersion = localStorage.getItem(`${APP_NAME}-${APP_VERSION}`);
    if (lastVersion !== APP_VERSION) {
      // remove all previous version keys
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith(APP_NAME) && key !== `${APP_NAME}-${APP_VERSION}`) {
          localStorage.removeItem(key);
        }
      });
      // set current version key
      localStorage.setItem(`${APP_NAME}-${APP_VERSION}`, APP_VERSION);
      window.location.reload(true);
    }
  }, []);

  return (
    <Switch>
      <PublicRoute exact path="/generate-api-key/:token" component={ApiKeyGenerator} />
      <PublicRoute exact path="/" component={LoginPage} />
      <PublicRoute exact path="/signup" component={SignupPage} />
      <PublicRoute exact path="/signup-success" component={SignupSuccess} />
      <PublicRoute exact path="/signup-canceled/:subscription" component={SignupCancel} />
      <PublicRoute exact path="/forgot-password" component={ForgotPasswordPage} />
      <PublicRoute
        exact
        path="/reset-password/:uidb64/:token"
        component={ResetPasswordPage}
      />
      <PublicRoute exact path="/set-password" component={SetPasswordPage} />
      <LeadsRoute path="/leads" component={LeadsPage} />

      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
};

export default AppRoute;
